module.exports = "img/matrix.9166e4b.svg";